import Vue from 'vue';
import router from '@/config/router';

const dataLayer = window.dataLayer || [];
const gtag = function gtag() {
  if (process.env.NODE_ENV !== 'production') {
    console.log(arguments);
    return;
  }

  dataLayer.push(arguments);
};

window.dataLayer = dataLayer;
window.gtag = gtag;

gtag('js', new Date());

router.afterEach((to) => {
  const meta = to.matched[to.matched.length - 1].components.default.metaInfo;
  const title = meta ? meta.title : to.name;
  const disableGtag = to.matched[to.matched.length - 1].components.default.disableGtag;

  if (disableGtag) {
    return;
  }

  gtag('config', process.env.VUE_APP_GTAG, {
    page_title: title,
    page_path: to.path,
  });
});

export const trackPageView = (title, path) => {
  gtag('config', process.env.VUE_APP_GTAG, {
    page_title: title,
    page_path: path,
  });
};

export const trackCategory = (category, action, label) => {
  gtag('event', action, {
    event_category: category,
    event_label: label,
  });
};

export const trackError = (error) => {
  const message = (error && error.message) || error;

  window.gtag('event', 'exception', {
    description: message,
    fatal: false,
  });

  window.gtag('event', message, {
    event_category: 'ERROR',
    event_label: router.currentRoute.name,
  });
};

Vue.prototype.$trackPageView = trackPageView;
Vue.prototype.$trackCategory = trackCategory;
Vue.prototype.$trackError = trackError;
